import { t } from "@/i18n-js/instance";
import { useCustomizeUIData } from "@circle-react-shared/CustomizeUI";
import { Button } from "@circle-react-uikit/Button";
import { Typography } from "@circle-react-uikit/Typography";

interface FormFooterProps {
  isPristine: boolean;
}

export const FormFooter = ({ isPristine }: FormFooterProps) => {
  const { formId, isSaving, onExit } = useCustomizeUIData();

  return (
    <div className="flex w-full items-center justify-between">
      <Typography.LabelSm weight="semibold">
        {!isPristine && t("unsaved_changes")}
      </Typography.LabelSm>
      <div className="flex gap-4">
        <Button type="button" onClick={onExit} variant="secondary">
          {t("cancel")}
        </Button>
        <Button
          form={formId}
          type="submit"
          disabled={isSaving}
          variant="circle"
        >
          {t("save_changes")}
        </Button>
      </div>
    </div>
  );
};
